import { AttachmentListHTML } from '@/components/attachment-list/attachment-list-html';
import { type FC, useState } from 'react';
import { PROCESSED_STATUSES } from '@/screens/order-inbounds/utils';
import { StyleSheet, View } from 'react-native';
import type { InboundHTMLAttachment } from '@/components/attachment-list/attachment-list-types';
import type { OrderMetadata } from '@/screens/order-inbounds/types';

interface Props {
  attachments: InboundHTMLAttachment[];
  onHighlightElementSelect: (searchInputUUID: string) => void;
  order: OrderMetadata;
  selectedAreaID?: string;
}

export const OrderInboundsDetailGroupedHtmlContent: FC<Props> = ({
  attachments,
  onHighlightElementSelect,
  order,
  selectedAreaID,
}) => {
  const [containerWidth, setContainerWidth] = useState(0);

  return (
    <View
      onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
      style={styles.container}
    >
      {attachments.map((attachment) => (
        <View key={attachment.url} style={styles.item}>
          <AttachmentListHTML
            htmlURL={attachment.url}
            onHighlightElementSelect={onHighlightElementSelect}
            selectedSearchInputUUID={selectedAreaID}
            showHighlights={!PROCESSED_STATUSES.has(order.status)}
            width={containerWidth}
          />
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
  item: { flex: 1 },
});
